import { MenuNavUtils } from '../../header/MenuNav'
import Glider from '../../../js/glider'

const SPECIALS_LIST_MOBILE_CLASS = 'specials-list--mobile'
const SPECIALS_LIST_DESKTOP_CLASS = 'specials-list--desktop'
const SPECIALS_LIST_SELECTOR = '.specials-list__container'
const SHOW_ALL_SPECIALS_CLASS = 'show-all'
const LABEL_SHOW_MORE = 'Show More'
const LABEL_SHOW_LESS = 'Show Less'

class SpecialsList {
  constructor (element) {
    this.element = element
    this.specialsContainer = element.querySelector(SPECIALS_LIST_SELECTOR)
    this.glider = null
    this.isDesktop = null
    this.updateAppearance()
    this.addEventListeners()
  }

  updateAppearance () {
    const newIsDesktopState = MenuNavUtils.isDesktopScreenSize()
    if (newIsDesktopState !== this.isDesktop) {
      this.isDesktop = newIsDesktopState
      this.element.classList.remove(SPECIALS_LIST_MOBILE_CLASS, SPECIALS_LIST_DESKTOP_CLASS)
      if (this.isDesktop) {
        this.element.classList.add(SPECIALS_LIST_DESKTOP_CLASS)
        if (this.glider) {
          this.glider.destroy()
          this.specialsContainer = this.element.querySelector(SPECIALS_LIST_SELECTOR)
        }
      } else {
        this.element.classList.add(SPECIALS_LIST_MOBILE_CLASS)
        this.specialsContainer.classList.add('glider')
        this.glider = new Glider(this.specialsContainer, {
          slidesToShow: 1,
          slidesToScroll: 1,
          rewind: true,
          draggable: true,
          scrollLock: true,
          resizeLock: true,
          responsive: [{
            breakpoint: 500,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          }],
          arrows: {
            prev: this.element.querySelector('.glider-prev'),
            next: this.element.querySelector('.glider-next')
          }
        })
      }
    }
  }

  addEventListeners () {
    this.headerShowMoreBtn = this.element.querySelector('.specials-list__header button')
    this.footerShowMoreBtn = this.element.querySelector('.specials-list__footer button')
    this.headerShowMoreBtn?.addEventListener('click', this.toggleShowHideMore.bind(this))
    this.footerShowMoreBtn?.addEventListener('click', this.toggleShowHideMore.bind(this))
    window.addEventListener('resize', this.updateAppearance.bind(this))
  }

  toggleShowHideMore () {
    if (this.specialsContainer.classList.contains(SHOW_ALL_SPECIALS_CLASS)) {
      this.specialsContainer.classList.remove(SHOW_ALL_SPECIALS_CLASS)
      this.updateLabelsShowBtn(LABEL_SHOW_MORE)
    } else {
      this.specialsContainer.classList.add(SHOW_ALL_SPECIALS_CLASS)
      this.updateLabelsShowBtn(LABEL_SHOW_LESS)
    }
  }

  updateLabelsShowBtn (txt) {
    Array.from(this.headerShowMoreBtn?.querySelectorAll('span'))
      .concat(Array.from(this.footerShowMoreBtn.querySelectorAll('span')))
      .forEach(span => span.textContent = txt)
  }
}

export default SpecialsList
